import { type CoreElement } from '@tunasong/schemas'

export const defaultEditorValue = [{ type: 'line', children: [{ text: '' }] }] satisfies CoreElement[]
